module.exports = __webpack_public_path__ + "media/application/images/ui/icon-footer-list-11ce243b3415075f9fa1acabeb95ed64.png";